<template>
  <article v-if="article" class="horizontal-teaser">
    <header v-if="article.attributes.teaser.image" class="horizontal-teaser__header">
      <div class="horizontal-teaser__image">
        <SpunqImage
          :image="article.attributes.teaser.image"
          :width="310"
          :height="207"
          :mobile-width="345"
          :mobile-height="230"
          mode="crop"
          lazy
        />
      </div>
    </header>
    <div class="horizontal-teaser__body">
      <TextTag v-if="article.attributes.teaser.preTitle" class="horizontal-teaser__tag">
        {{ article.attributes.teaser.preTitle }}
      </TextTag>
      <TextTag
        v-else-if="article.relationships.channels"
        class="channel-link horizontal-teaser__tag"
        :class="{
          'horizontal-teaser__tag--medien': channelType === 'medien',
          'horizontal-teaser__tag--pharmainfo': channelType === 'pharmainfo',
          'horizontal-teaser__tag--fortbildung': channelType === 'fortbildung',
          'horizontal-teaser__tag--software': channelType === 'software',
        }"
      >
        <ChannelLink :channels="article.relationships.channels">
          {{ article.relationships.channels | getChannelName($config.portalId) }}
        </ChannelLink>
      </TextTag>
      <h2
        v-if="article.attributes.teaser.title"
        :title="article.attributes.teaser.title"
        class="horizontal-teaser__title"
      >
        <ArticleLink :article="article" class="teaser-link">
          {{ article.attributes.teaser.title }}
        </ArticleLink>
      </h2>
      <p
        v-if="article.attributes.teaser.leadText"
        :title="article.attributes.teaser.leadText"
        class="horizontal-teaser__text"
      >
        {{ article.attributes.teaser.leadText }}
      </p>
      <AuthorElement
        v-if="article.relationships.authors.length > 0"
        :author="article.relationships.authors[0]"
        class="horizontal-teaser__author"
      />
    </div>
  </article>
</template>

<script>
import SpunqImage from '@/components/ui/image/spunq-image'
import TextTag from '@/components/ui/tag/text'
import AuthorElement from '@/components/author/default'
import ArticleLink from '@/components/article/link'
import ChannelLink from '@/components/channel/link'

export default {
  components: {
    SpunqImage,
    TextTag,
    AuthorElement,
    ArticleLink,
    ChannelLink,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    channelType() {
      return this.article?.relationships?.channels?.[0]?.attributes?.name?.toLowerCase()
    },
  },
}
</script>

<style lang="scss">
@import '../../../css/import/vars';

.horizontal-teaser {
  width: 100%;
  display: flex;
  position: relative;

  &__image {
    overflow: hidden;

    @at-root .horizontal-teaser:hover {
      img {
        transform: scale(1.01);
      }
    }
  }

  &__header {
    flex: 1 1 100%;
    min-width: 60px;
    max-width: 60px;
    margin-right: 1rem;

    @media all and (min-width: $screen-width-767) {
      min-width: 200px;
      max-width: 200px;
    }
  }

  &__body {
    flex: 1 1 100%;
  }

  &__title {
    font-size: 16px;
    margin-bottom: 0.5rem;

    @media all and (min-width: $screen-width-767) {
      font-size: 20px;
    }

    .teaser-link {
      color: $color-text;
    }
  }

  &__text {
    margin-bottom: 0.5rem;
  }

  &__author {
    justify-content: flex-start;

    .author__name {
      color: $color-text;
    }
  }

  &__tag {
    display: block;
    margin-top: -4px;
    position: relative;
    z-index: 3;

    &--medien {
      a {
        color: $color-medien;
      }
    }

    &--pharmainfo {
      a {
        color: $color-pharmainfo;
      }
    }

    &--fortbildung {
      a {
        color: $color-fortbildung;
      }
    }

    &--software {
      a {
        color: $color-software;
      }
    }
  }
}
</style>
